import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { login, logout, getUser, isSessionActive, csrfCookie } from '@/http/api'
import { useAppStateStore } from '@/stores/appState'

export const useUserStore = defineStore('userStore', () => {
  const userData = ref({})
  const userRole = ref('public')
  let sessionValidated = false
  let sessionPromise = null

  const isLoggedIn = computed(() => !!userData.value.email)

  async function fetchUser() {
    const { data } = await getUser()
    userData.value = data
    userRole.value = data.role
  }

  async function restoreSession() {
    if (!sessionValidated) {
      if (!sessionPromise) {
        sessionPromise = (async () => {
          try {
            const appState = useAppStateStore()
            const { data } = await isSessionActive()
            if (data.active) {
              await fetchUser()
              await appState.fetchRoleState()
            } else {
              await appState.fetchGeneralState()
            }
            sessionValidated = true
          } catch (e) {
            sessionPromise = null
            throw e
          }
        })()
      }
      await sessionPromise
    }
  }

  async function handleLogin(credentials) {
    const appState = useAppStateStore()
    await csrfCookie()
    await login(credentials)
    await fetchUser()
    await appState.fetchRoleState()
    sessionValidated = true
  }

  async function handleLogout() {
    const appState = useAppStateStore()
    await logout()
    await csrfCookie()
    userData.value = {}
    userRole.value = 'public'
    await appState.fetchGeneralState()
    sessionValidated = true
  }

  return {
    userData,
    userRole,
    isLoggedIn,
    restoreSession,
    handleLogin,
    handleLogout
  }
})
